<template>
  <div class="screen-header">
    <div class="header-deco left">
      <span class="chev">‹‹‹</span>
      <span class="deco-line"></span>
    </div>
    <div class="header-center" @click="toFirstPage">
      <h1 class="header-title">史河科技售后监控平台</h1>
    </div>
    <div class="header-deco right">
      <span class="deco-line"></span>
      <span class="chev">›››</span>
    </div>
    <div class="header-actions">
      <span class="clock">{{ nowText }}</span>
      <el-dropdown @command="userHandleCommand" placement="bottom">
        <span class="user-trigger">退出</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in userMenuList"
            :key="index"
            :command="index"
            >{{ item.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { localStorageClean } from "@/common/localStorage/localStorageManage";

export default {
  name: "homeMenu",
  props: {
    chooseMenu: String,
  },
  data() {
    return {
      menuList: [],
      userMenuList: [],
      nowText: "",
      clockTimer: null,
    };
  },
  methods: {
    tickClock() {
      const d = new Date();
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      this.nowText =
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds());
    },
    userHandleCommand(command) {
      if (this.userMenuList[command].path === "out") {
        this.outLogin();
      } else {
        this.$router.push("/" + this.userMenuList[command].path);
      }
    },
    toFirstPage() {
      if (!this.menuList.length) return;
      this.$router.push("/" + this.menuList[0].path);
    },
    outLogin() {
      localStorageClean();
      this.$router.push("/login");
    },
  },
  mounted() {
    this.userMenuList = [{ name: "退出登录", path: "out" }];
    this.menuList = [{ name: "工单监控", path: "aftersaleOverview" }];
    this.tickClock();
    this.clockTimer = setInterval(this.tickClock, 1000);
  },
  beforeDestroy() {
    clearInterval(this.clockTimer);
  },
};
</script>

<style scoped lang="scss">
.screen-header {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  height: 64px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(180deg, rgba(0, 50, 100, 0.45) 0%, rgba(4, 11, 26, 0) 100%),
    radial-gradient(ellipse at 50% 0%, rgba(0, 180, 255, 0.18) 0%, transparent 70%);
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent 5%,
      rgba(0, 229, 255, 0.25) 20%,
      rgba(0, 229, 255, 0.85) 50%,
      rgba(0, 229, 255, 0.25) 80%,
      transparent 95%
    );
    box-shadow: 0 0 12px rgba(0, 229, 255, 0.7);
  }

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 48%;
    height: 3px;
    transform: translateX(-50%);
    background: linear-gradient(
      90deg,
      transparent,
      #00e5ff 30%,
      #58e2f1 50%,
      #00e5ff 70%,
      transparent
    );
    clip-path: polygon(0 100%, 8% 0, 92% 0, 100% 100%);
    box-shadow: 0 0 14px rgba(0, 229, 255, 0.85);
  }
}

.header-deco {
  position: absolute;
  top: 50%;
  width: 24%;
  display: flex;
  align-items: center;
  gap: 8px;
  transform: translateY(-50%);
  opacity: 0.9;

  &.left {
    left: 3%;
    .deco-line {
      background: linear-gradient(90deg, transparent, rgba(0, 229, 255, 0.7));
    }
  }
  &.right {
    right: 3%;
    .deco-line {
      background: linear-gradient(270deg, transparent, rgba(0, 229, 255, 0.7));
    }
  }
}

.deco-line {
  flex: 1;
  height: 1px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: -2px;
    left: 0;
    right: 0;
    height: 5px;
    background: repeating-linear-gradient(
      90deg,
      rgba(0, 229, 255, 0.45) 0,
      rgba(0, 229, 255, 0.45) 3px,
      transparent 3px,
      transparent 8px
    );
    opacity: 0.55;
  }
}

.chev {
  flex-shrink: 0;
  color: #00e5ff;
  font-size: 12px;
  letter-spacing: -3px;
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.8);
}

.header-center {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  z-index: 1;
  padding: 6px 36px 10px;
  clip-path: polygon(6% 0, 94% 0, 100% 100%, 0 100%);
  background: linear-gradient(
    180deg,
    rgba(0, 140, 200, 0.28) 0%,
    rgba(0, 60, 120, 0.12) 100%
  );
  border-bottom: 1px solid rgba(0, 229, 255, 0.35);
}

.header-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 6px;
  color: #fff;
  text-shadow:
    0 0 16px rgba(0, 200, 255, 0.85),
    0 0 4px rgba(0, 229, 255, 0.6),
    0 2px 0 rgba(0, 40, 80, 0.8);
  white-space: nowrap;
}

.header-actions {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 14px;
  z-index: 2;
}

.clock {
  color: #00e5ff;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  letter-spacing: 1px;
  padding: 4px 12px;
  border: 1px solid rgba(0, 229, 255, 0.45);
  background: rgba(0, 40, 70, 0.55);
  box-shadow:
    inset 0 0 10px rgba(0, 180, 255, 0.15),
    0 0 10px rgba(0, 200, 255, 0.25);
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.6);
}

.user-trigger {
  color: #00e5ff;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid rgba(0, 229, 255, 0.45);
  padding: 4px 12px;
  clip-path: polygon(8% 0, 100% 0, 92% 100%, 0 100%);
  background: rgba(0, 50, 90, 0.4);
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 229, 255, 0.18);
    box-shadow: 0 0 10px rgba(0, 229, 255, 0.4);
  }
}
</style>
